import type { Division, TournamentDivision } from "@/db/schema";
import type { Gender } from "@/db/schema/shared";

export function getPlayerLevel(tp: {
  levelAtTournament?: {
    abbreviated: string | null;
    name: string;
    order: number;
  } | null;
  profile: {
    level: { abbreviated: string | null; name: string; order: number } | null;
  };
}) {
  return tp.levelAtTournament ?? tp.profile.level;
}

export function getLevelDisplay(
  level: { abbreviated: string | null; name: string; order: number } | null,
  min?: number,
) {
  if (min !== undefined && (!level || level.order <= min)) {
    return "";
  }

  return (level?.abbreviated || level?.name)?.toUpperCase() || "N";
}

export function getGenderDisplay(
  gender: Gender,
  maxAge: number | null | undefined,
) {
  // Only anonymized (deleted) profiles carry "unknown"; divisions never do.
  // Guarded explicitly so it cannot fall through to "Girl's"/"Women's" below.
  if (gender === "unknown") return "";
  if (gender === "coed") return "Coed";
  if (maxAge) return gender === "male" ? "Boy's" : "Girl's";
  return gender === "male" ? "Men's" : "Women's";
}

export function getTournamentDivisionDisplay({
  name,
  teamSize,
  gender,
  displayGender,
  displayDivision,
  division: { maxAge, name: divisionName, display: divisionDisplay },
}: Pick<TournamentDivision, "name" | "teamSize" | "gender"> & {
  displayGender?: boolean | null;
  displayDivision?: boolean | null;
  division: Pick<Division, "maxAge" | "name" | "display">;
}) {
  let display = `${name ?? ""}`;

  if (!name || displayGender) {
    if (display.length) {
      display += " ";
    }
    display += getGenderDisplay(gender, maxAge);
  }

  if (!name || displayDivision) {
    display += ` ${divisionDisplay ?? divisionName.toUpperCase()}`;
  }

  if (teamSize === 4) {
    display += " 4's";
  } else if (teamSize === 6) {
    display += " 6's";
  }

  return display;
}
